import React from "react";

function SmallLoading() {
  return (
    <div className="loading-con">
      <div className="lds-ring small-loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default SmallLoading;
